import { CheckCircleIcon } from '@calendly/ui/components/icons'
const colorTextSuccess = 'var(--colorTextSuccess, var(--coreColorGreen800))'

import { useI18n } from 'locales'

import { SuccessBanner } from './styles'

export const PhoneVerificationSuccessBanner = () => {
  const { i18n } = useI18n()

  return (
    <SuccessBanner>
      <CheckCircleIcon color={colorTextSuccess} />
      {i18n.t('booking.phone_verification.scheduled_success')}
    </SuccessBanner>
  )
}
